/* Snuzone – Mobile Drawer Search Panel (v8 – Prefix-Merge)
   v8: Produkt-Treffer als MERGE aus zwei Quellen:
       1) /search/suggest.json (Predictive-Engine, natives Prefix-Matching:
          "pab" -> Pablo) — noetig, weil options[prefix]=last von der vollen
          Storefront-Suche engine-seitig nicht mehr angewendet wird
          (verifiziert 08/2026: Query mit/ohne Prefix liefert identische Treffer).
       2) Volle Suche (templates/search.ajax.liquid) — Typo-Toleranz/Relaxation
          ("pablp" -> Pablo) bleibt erhalten.
       Dedupe per handle, Prefix-Treffer zuerst. Gesamte v7-Hold-/Restore-Logik
       unveraendert.
*/
/* Snuzone – Mobile Drawer Search Panel (v7 – Hold ueber die gesamte Quick-Shop-Session)
   v7: Der programmatische Drawer-Close feuert auch beim SCHLIESSEN des Modals
       (nicht nur beim Oeffnen). Das Hold-Fenster endet deshalb nicht mehr nach
       fester Zeit, sondern erst 600ms NACH dem Modal-Close – der Observer
       stellt die Klasse im selben Frame wieder her, kein sichtbares
       Zu-und-wieder-Auf mehr. Restore (v4) bleibt als stiller Fallback und
       greift nur noch, wenn Drawer/Panel wirklich fehlen.
*/
/* Snuzone – Mobile Drawer Search Panel (v6 – Drawer-Hold)
   v6: Der Quick-Shop-Init (custom.js/theme) schliesst den NavDrawer
       programmatisch – vorbei an closeDrawer() und damit am v5-Guard
       (Diagnose: drawer--is-open wird exakt beim ProductForm-Init entfernt,
       Mechanismus weder classList.toggle noch closeDrawer). Fix: waehrend
       des Quick-Shop-Fensters (ATC-Tap + 2,5s) stellt ein MutationObserver
       drawer--is-open + snzm-active sofort wieder her, egal wer schliesst.
       Ausnahme: Cart-Drawer offen -> Hold endet (Warenkorb-Flow hat Vorrang).
*/
/* Snuzone – Mobile Drawer Search Panel (v5 – Proxy-Klick-Guard)
   v5: window.__snzQuickShopClick-Flag fuer die Dauer des synthetischen
       Proxy-Klicks. closeDrawer() in header.liquid prueft dieses Flag
       (Mini-Patch) und ignoriert den Klick – egal welcher Listener
       (Capture oder Bubble) ihn verarbeitet. Diagnose per Stacktrace:
       Capture-Listener in header.liquid schloss den Drawer beim Proxy-Klick.
*/
/* Snuzone – Mobile Drawer Search Panel (v4 – Kompakt + Quick-Shop-Kontext-Restore)
   v4: Schliesst irgendetwas den Drawer waehrend des Quick-Shop-Flows
       (Outside-Click, theme.js, App), wird der Suchkontext nach dem
       Schliessen des Modals automatisch wiederhergestellt: Drawer auf,
       Panel aktiv, Suchbegriff + Treffer wieder da. Kein Restore, wenn
       der Cart-Drawer uebernommen hat (Kunde ist im Warenkorb-Flow).
*/
/* Snuzone – Mobile Drawer Search Panel (v3 – Kompakt / Variante A Hybrid)
   Datei: assets/snuzone-search-mobile.js
   Scope: <= 989px (Drawer).
     - Idle: Zuletzt angesehen als horizontaler Swipe-Strip (schmale Karten)
     - Typing: kompakte Listen-Rows (Thumb + Titel + Meta + Preis + Quick-Add)
     - Quick Shop via Proxy-Trigger-Pattern (Drawer bleibt offen; header.liquid-Patch)
     - Letzte Suchen: localStorage 'snzs_recent_searches' (geteilt mit Desktop)
     - Produkt-Treffer via VOLLE Suche (templates/search.ajax.liquid v2)
     - v3: Wishlist entfernt (kein Platz im Kompakt-Layout), native Karten-Klone
       durch eigenes Kompakt-Markup ersetzt
   Events laufen in der CAPTURE-Phase auf document, damit die native Impulse-Suche
   sie nicht via stopPropagation abfangen kann.
   Desktop-Logik (snuzone-search.js) bleibt komplett unberuehrt. */
(function () {
  'use strict';

  if (window.SnzmSearchMobile && typeof window.SnzmSearchMobile.reinit === 'function') {
    window.SnzmSearchMobile.reinit();
    return;
  }

  var MOBILE_MQ = window.matchMedia('(max-width: 989px)');
  var RS_KEY = 'snzs_recent_searches';

  var root, drawer, input;
  var elIdle, elTyping, elRecent, elRecentGrid, elFallback,
      elProductsGrid, elEmpty, elViewall, elSearches, elSearchesList;

  var cfg = {};
  var debounceTimer = null, currentController = null, docBound = false;

  var ICON_BAG = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 7h12l1 13H5L6 7z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>';
  var ICON_X = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  /* ---------- Helpers ---------- */
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function hasTag(p, tag) {
    if (!tag || !p || !p.tags || !Array.isArray(p.tags)) return false;
    return p.tags.map(String).map(function (t) { return t.toLowerCase(); }).indexOf(tag) !== -1;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, cfg.moneyFormat); } catch (e) {}
    }
    var fmt = cfg.moneyFormat;
    function f(precision, thousands, decimal) {
      var n = (cents / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var value;
    switch (placeholder) {
      case 'amount_no_decimals': value = f(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = f(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = f(0, '.', ','); break;
      case 'amount_with_space_separator': value = f(2, ' ', ','); break;
      default: value = f(2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function priceToCents(price) {
    if (price == null) return 0;
    if (typeof price === 'number') return price;
    var n = String(price).replace(/[^\d.,]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    var f = parseFloat(n);
    return isNaN(f) ? 0 : Math.round(f * 100);
  }

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  function resizeImg(url) {
    if (!url) return '';
    return String(url).replace(/(\.[^.\/]+)(\?[^?]*)?$/, '_300x$1$2');
  }

  function priceHTML(priceCents, capCents) {
    if (typeof capCents === 'number' && capCents > priceCents) {
      return '<span class="snzm-price--now">' + formatMoney(priceCents) + '</span>'
        + '<span class="snzm-price--was">' + formatMoney(capCents) + '</span>';
    }
    return formatMoney(priceCents);
  }

  /* ---------- Normalisierung der beiden Produkt-Quellen (v8) ---------- */

  /* Volle Suche (templates/search.ajax.liquid v3): Cents, Boolean isNew */
  function normFull(p) {
    var priceCents = priceToCents(p.price);
    return {
      handle: p.handle || handleFromUrl(p.url),
      url: p.url || '',
      image: p.image || '',
      title: p.title || '',
      priceCents: priceCents,
      capCents: (typeof p.cap === 'number' && p.cap > priceCents) ? p.cap : null,
      available: p.available !== false,
      isNew: p.isNew === true
    };
  }

  /* Predictive (suggest.json): Preise als Strings, Tags-Array vorhanden */
  function normSuggest(p) {
    var priceCents = priceToCents(p.price);
    var capCents = priceToCents(p.compare_at_price_max);
    var img = p.image || (p.featured_image && p.featured_image.url) || '';
    return {
      handle: p.handle || handleFromUrl(p.url),
      url: p.url || '',
      image: img ? resizeImg(img) : '',
      title: p.title || '',
      priceCents: priceCents,
      capCents: (capCents > priceCents) ? capCents : null,
      available: p.available !== false,
      isNew: hasTag(p, cfg.newTag)
    };
  }

  /* ---------- Strip-Karte (Idle) ---------- */
  function stripCardHTML(o) {
    var url = o.url || '#';
    var hasSale = typeof o.capCents === 'number' && o.capCents > o.priceCents;
    var salePct = hasSale ? Math.round((1 - o.priceCents / o.capCents) * 100) : 0;

    var tag = '';
    if (hasSale && salePct > 0) {
      tag = '<span class="snzm-scard__tag snzm-scard__tag--sale">-' + salePct + '%</span>';
    } else if (o.isNew && cfg.showBadge) {
      tag = '<span class="snzm-scard__tag">' + esc(cfg.badgeLabel) + '</span>';
    }

    return '<div class="snzm-scard" data-product-handle="' + esc(o.handle || '') + '">'
      + tag
      + '<a href="' + esc(url) + '" class="snzm-scard__media">'
      + (o.image ? '<img class="snzm-scard__img" src="' + esc(o.image) + '" alt="' + esc(o.title) + '" loading="lazy">' : '')
      + '</a>'
      + '<a href="' + esc(url) + '" class="snzm-scard__title">' + esc(o.title) + '</a>'
      + '<div class="snzm-scard__price">' + priceHTML(o.priceCents, o.capCents) + '</div>'
      + (o.handle
        ? '<button type="button" class="snzm-scard__atc" data-mobile-add-to-cart data-handle="' + esc(o.handle) + '" aria-label="Add to cart"><span class="snzm-atc__circle">' + ICON_BAG + '</span></button>'
        : '')
      + '</div>';
  }

  /* ---------- Listen-Row (Typing) ---------- */
  function rowHTML(o) {
    var url = o.url || '#';
    var subParts = [];
    if (o.isNew && cfg.showBadge) subParts.push('<b>' + esc(cfg.badgeLabel) + '</b>');
    if (o.mg) subParts.push(esc(o.mg));
    if (o.strength) subParts.push(esc(o.strength));
    var sub = subParts.length ? '<span class="snzm-row__sub">' + subParts.join(' · ') + '</span>' : '';

    return '<div class="snzm-row" data-product-handle="' + esc(o.handle || '') + '">'
      + '<a href="' + esc(url) + '" class="snzm-row__main">'
      + '<span class="snzm-row__thumb">'
      + (o.image ? '<img src="' + esc(o.image) + '" alt="' + esc(o.title) + '" loading="lazy">' : '')
      + '</span>'
      + '<span class="snzm-row__mid">'
      + '<span class="snzm-row__title">' + esc(o.title) + '</span>'
      + sub
      + '<span class="snzm-row__price">' + priceHTML(o.priceCents, o.capCents) + '</span>'
      + '</span>'
      + '</a>'
      + (o.handle
        ? '<button type="button" class="snzm-row__atc" data-mobile-add-to-cart data-handle="' + esc(o.handle) + '" aria-label="Add to cart"><span class="snzm-atc__circle">' + ICON_BAG + '</span></button>'
        : '')
      + '</div>';
  }

  /* ---------- Recently Viewed (rv_products) ---------- */
  function getRecentItems() {
    try {
      var raw = localStorage.getItem('rv_products');
      if (!raw) return [];
      var items = JSON.parse(raw);
      if (!Array.isArray(items)) return [];
      return items.map(function (i) {
        return (typeof i === 'object' && i !== null && i.handle) ? i : { handle: String(i), strength: null };
      });
    } catch (e) { return []; }
  }
  function pruneRecent(invalid) {
    if (!invalid.length) return;
    try {
      var keep = getRecentItems().filter(function (i) { return invalid.indexOf(i.handle) === -1; });
      localStorage.setItem('rv_products', JSON.stringify(keep));
    } catch (e) {}
  }
  function fetchRecentProduct(item) {
    return fetch(cfg.localePrefix + '/products/' + item.handle + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (p) { if (p) p._rv = item; return p; })
      .catch(function () { return null; });
  }
  function loadRecent() {
    if (!elRecent) { return; }
    var items = getRecentItems();
    if (cfg.currentHandle) items = items.filter(function (i) { return i.handle !== cfg.currentHandle; });
    items = items.slice(0, cfg.recentLimit);
    if (items.length === 0) { showFallback(); return; }
    Promise.all(items.map(fetchRecentProduct)).then(function (results) {
      var invalid = [], products = [];
      results.forEach(function (p, idx) {
        if (!p) { invalid.push(items[idx].handle); return; }
        if (!p.available) return;
        products.push(p);
      });
      pruneRecent(invalid);
      if (products.length === 0) { showFallback(); return; }
      elRecentGrid.innerHTML = products.map(function (p) {
        return stripCardHTML({
          handle: p.handle,
          url: cfg.localePrefix + '/products/' + p.handle,
          image: p.featured_image ? resizeImg(p.featured_image) : '',
          title: p.title,
          priceCents: p.price,
          capCents: (p.compare_at_price && p.compare_at_price > p.price) ? p.compare_at_price : null,
          isNew: hasTag(p, cfg.newTag)
        });
      }).join('');
      if (elFallback) elFallback.hidden = true;
      elRecent.hidden = false;
    });
  }
  function showFallback() {
    if (elRecent) elRecent.hidden = true;
    if (elFallback) elFallback.hidden = false;
  }

  /* ---------- Letzte Suchen (localStorage, geteilt mit Desktop) ---------- */
  function rsLoad() {
    try {
      var raw = JSON.parse(localStorage.getItem(RS_KEY));
      return Array.isArray(raw) ? raw.filter(function (q) { return typeof q === 'string' && q.trim(); }) : [];
    } catch (e) { return []; }
  }
  function rsPersist(arr) {
    try { localStorage.setItem(RS_KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function rsSave(q) {
    q = String(q || '').trim();
    if (!q || q.length > 60) return;
    var arr = rsLoad().filter(function (item) { return item.toLowerCase() !== q.toLowerCase(); });
    arr.unshift(q);
    rsPersist(arr.slice(0, cfg.searchesLimit));
  }
  function rsRender() {
    if (!cfg.searchesEnabled || !elSearches || !elSearchesList) return;
    var arr = rsLoad().slice(0, cfg.searchesLimit);
    if (!arr.length) { elSearches.hidden = true; elSearchesList.innerHTML = ''; return; }
    var html = '';
    for (var i = 0; i < arr.length; i++) {
      var q = arr[i];
      html += '<span class="snzm-chip">'
        + '<a class="snzm-chip__link" href="' + cfg.localePrefix + '/search?q=' + encodeURIComponent(q) + '&type=product">' + esc(q) + '</a>'
        + '<button type="button" class="snzm-chip__x" data-q="' + esc(q) + '" aria-label="Remove search">' + ICON_X + '</button>'
        + '</span>';
    }
    elSearchesList.innerHTML = html;
    elSearches.hidden = false;
  }

  /* ---------- Quick Shop (Proxy-Trigger-Pattern) ----------
     Der native picoapp-Handler bindet nur beim initialen app.mount() –
     unsere Karten entstehen spaeter. Ein bereits gemounteter nativer
     Trigger (ausserhalb Drawer, RV-Track und Desktop-Panel) wird mit
     getauschtem data-handle synchron geklickt. Der Drawer bleibt offen –
     der Outside-Click-Handler in header.liquid ignoriert Modal- und
     ATC-Klicks (header.liquid-Patch erforderlich). */
  function triggerQuickShop(handle) {
    var proxy = null;
    var candidates = document.querySelectorAll('[data-mobile-add-to-cart]');
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c.closest('#NavDrawer') && !c.closest('.rv-track') && !c.closest('.snzs-overlay')) { proxy = c; break; }
    }

    if (proxy) {
      var originalHandle = proxy.getAttribute('data-handle');
      proxy.setAttribute('data-handle', handle);
      /* Guard: closeDrawer() in header.liquid ignoriert diesen Klick */
      window.__snzQuickShopClick = true;
      try {
        proxy.click();
      } finally {
        window.__snzQuickShopClick = false;
      }
      if (originalHandle !== null) proxy.setAttribute('data-handle', originalHandle);
      else proxy.removeAttribute('data-handle');
      return;
    }

    /* Fallback: nativen Flow replizieren (ohne app.mount-Garantie) */
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || (cfg.localePrefix + '/');
    fetch(rootPath + 'products/' + handle + '?view=ajax-product')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var modal = document.querySelector('.ModalForm');
        if (!modal) return;
        modal.innerHTML = html;
        modal.classList.add('active');
        var mClose = document.querySelector('[data-close-popup]');
        if (mClose) {
          mClose.addEventListener('click', function () {
            modal.classList.add('close-animation');
            setTimeout(function () {
              modal.classList.remove('close-animation');
              modal.classList.remove('active');
            }, 400);
            setTimeout(function () {
              var popup = document.querySelector('.product-custom-popup');
              if (popup) popup.remove();
            }, 500);
          });
        }
        if (window.app && typeof window.app.mount === 'function') {
          try { window.app.mount(); } catch (err) {}
        }
      })
      .catch(function () {});
  }

  /* ---------- Quick-Shop Drawer-Hold ---------- */
  var holdObs = null, holdTimer = null;

  function qsHoldStop() {
    if (holdObs) { holdObs.disconnect(); holdObs = null; }
    if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
  }

  function qsHoldStart() {
    if (!drawer) return;
    /* Body-Klassen des offenen Drawers merken (Scroll-Lock etc.) */
    var bodyDrawerClasses = Array.prototype.filter.call(document.body.classList, function (c) {
      return c.indexOf('drawer-open') > -1;
    });
    qsHoldStop();
    holdObs = new MutationObserver(function () {
      /* Cart-Drawer uebernimmt? Dann Hold beenden (Warenkorb-Flow hat Vorrang) */
      var cart = document.getElementById('CartDrawer');
      if (cart && cart.classList.contains('drawer--is-open')) { qsHoldStop(); return; }

      if (!drawer.classList.contains('drawer--is-open')) {
        drawer.classList.add('drawer--is-open');
        drawer.classList.add('snzm-active');
        bodyDrawerClasses.forEach(function (c) { document.body.classList.add(c); });
      }
    });
    holdObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    /* Kein festes Zeitfenster: Hold laeuft bis nach dem Modal-Close
       (siehe qsWatchModal) bzw. bis der Cart-Drawer uebernimmt */
  }

  /* ---------- Quick-Shop-Kontext-Restore ---------- */
  var qsRestore = null;
  var modalObs = null;

  function qsSnapshot() {
    qsRestore = {
      q: input ? input.value : '',
      active: !!(drawer && drawer.classList.contains('snzm-active'))
    };
  }

  function qsWatchModal(attempt) {
    var modal = document.querySelector('.ModalForm');
    if (!modal) {
      /* Modal-Container ggf. noch nicht im DOM: kurz nachfassen */
      if ((attempt || 0) < 10) setTimeout(function () { qsWatchModal((attempt || 0) + 1); }, 100);
      return;
    }
    if (modalObs) { modalObs.disconnect(); modalObs = null; }
    var wasActive = modal.classList.contains('active');
    modalObs = new MutationObserver(function () {
      var isActive = modal.classList.contains('active');
      if (isActive && !wasActive) { wasActive = true; return; }
      if (!isActive && wasActive) {
        wasActive = false;
        modalObs.disconnect();
        modalObs = null;
        /* Nachlaufzeit: der programmatische Drawer-Close feuert auch beim
           Modal-Schliessen – solange haelt der Hold-Observer dagegen.
           Danach Hold beenden und (nur falls noetig) Zustand wiederherstellen. */
        setTimeout(function () {
          qsHoldStop();
          qsRestoreState();
        }, 600);
      }
    });
    modalObs.observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  function qsRestoreState() {
    if (!qsRestore) return;
    var st = qsRestore;
    qsRestore = null;
    if (!MOBILE_MQ.matches || !drawer) return;

    var cart = document.getElementById('CartDrawer');
    if (cart && cart.classList.contains('drawer--is-open')) return;

    /* Hold hat alles gehalten? Dann ist nichts zu tun – kein Re-Render */
    if (drawer.classList.contains('drawer--is-open') && drawer.classList.contains('snzm-active')) return;

    if (!drawer.classList.contains('drawer--is-open')) {
      var burger = document.querySelector('.js-drawer-open-nav');
      if (burger) burger.click();
    }
    if (st.active) {
      drawer.classList.add('snzm-active');
      if (input) input.value = st.q || '';
      refreshContent(st.q || '');
    }
  }

  /* ---------- Predictive (v8: Merge Prefix + volle Suche) ---------- */
  function runPredictive(q) {
    if (currentController) currentController.abort();
    currentController = ('AbortController' in window) ? new AbortController() : null;
    var myController = currentController;
    var signal = currentController ? currentController.signal : undefined;

    /* 1) Volle Suche: Typo-Toleranz/Relaxation. options[prefix]=last bleibt
       im Request (harmlos; greift automatisch wieder, falls Shopify die
       Prefix-Regression behebt). */
    var fullP = fetch(
      cfg.localePrefix + '/search?q=' + encodeURIComponent(q)
        + '&type=product&options[prefix]=last&view=ajax',
      { signal: signal, credentials: 'same-origin' }
    )
      .then(function (res) { return res.ok ? res.text() : '[]'; })
      .then(function (text) {
        try { return JSON.parse(text) || []; } catch (e) { return []; }
      })
      .catch(function () { return []; });

    /* 2) Predictive-Engine: natives Prefix-Matching ("pab" -> Pablo) */
    var sugP = fetch(
      cfg.localePrefix + '/search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product'
        + '&resources[limit]=' + Math.min(cfg.productLimit, 10)
        + '&resources[options][unavailable_products]=last',
      { signal: signal, credentials: 'same-origin' }
    )
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });

    Promise.all([fullP, sugP]).then(function (res) {
      if (currentController !== myController) return; // veraltete Antwort verwerfen

      var full = res[0] || [];
      var sug = res[1];
      var sugProducts = (sug && sug.resources && sug.resources.results && sug.resources.results.products) || [];

      /* Merge: Prefix-Treffer (Predictive) zuerst, dann Zusatz-Treffer der
         vollen Suche (Typos/Relaxation). Dedupe per handle. */
      var seen = {};
      var merged = [];
      sugProducts.forEach(function (p) {
        var o = normSuggest(p);
        if (o.handle && !seen[o.handle]) { seen[o.handle] = 1; merged.push(o); }
      });
      full.forEach(function (p) {
        var o = normFull(p);
        if (o.handle && !seen[o.handle]) { seen[o.handle] = 1; merged.push(o); }
      });

      merged.sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); });

      if (merged.length) {
        elProductsGrid.innerHTML = merged.slice(0, cfg.productLimit).map(rowHTML).join('');
        if (elEmpty) elEmpty.hidden = true;
      } else {
        elProductsGrid.innerHTML = '';
        if (elEmpty) elEmpty.hidden = false;
      }

      if (elViewall) {
        elViewall.textContent = cfg.viewallLabel.replace('[query]', q);
        elViewall.setAttribute('href', cfg.localePrefix + '/search?q=' + encodeURIComponent(q) + '&type=product');
      }
    });
  }

  /* ---------- State ---------- */
  function setState(state) {
    if (!elIdle || !elTyping) return;
    if (state === 'typing') { elIdle.hidden = true; elTyping.hidden = false; }
    else { elTyping.hidden = true; elIdle.hidden = false; loadRecent(); rsRender(); }
  }
  function refreshContent(q) {
    if (q == null) q = input ? input.value : '';
    q = q.trim();
    clearTimeout(debounceTimer);
    if (q === '') { setState('idle'); return; }
    setState('typing');
    debounceTimer = setTimeout(function () { runPredictive(q); }, 180);
  }

  function enterSearchMode() {
    if (!MOBILE_MQ.matches || !drawer) return;
    if (!drawer.classList.contains('snzm-active')) drawer.classList.add('snzm-active');
    refreshContent();
  }
  function exitSearchMode(clearInput) {
    if (!drawer) return;
    drawer.classList.remove('snzm-active');
    if (clearInput && input) input.value = '';
    if (elIdle) setState('idle');
  }

  /* ---------- DOM ---------- */
  function cacheEls() {
    elIdle         = root.querySelector('[data-snzm-state="idle"]');
    elTyping       = root.querySelector('[data-snzm-state="typing"]');
    elRecent       = root.querySelector('[data-snzm-recent]');
    elRecentGrid   = root.querySelector('[data-snzm-recent-grid]');
    elFallback     = root.querySelector('[data-snzm-fallback]');
    elProductsGrid = root.querySelector('[data-snzm-products-grid]');
    elEmpty        = root.querySelector('[data-snzm-empty]');
    elViewall      = root.querySelector('[data-snzm-viewall]');
    elSearches     = root.querySelector('[data-snzm-searches]');
    elSearchesList = root.querySelector('[data-snzm-searches-list]');
  }

  function readCfg() {
    cfg.localeRoot   = root.getAttribute('data-locale-root') || '/';
    cfg.localePrefix = (cfg.localeRoot === '/' ? '' : cfg.localeRoot.replace(/\/$/, ''));
    cfg.recentLimit  = Math.min(parseInt(root.getAttribute('data-recent-limit'), 10) || 6, 12);
    cfg.productLimit = parseInt(root.getAttribute('data-product-limit'), 10) || 8;
    cfg.newTag       = (root.getAttribute('data-new-tag') || '').toLowerCase();
    cfg.badgeLabel   = root.getAttribute('data-badge-label') || '';
    cfg.showBadge    = root.getAttribute('data-show-badge') === 'true';
    cfg.viewallLabel = root.getAttribute('data-viewall-label') || 'View all results';
    cfg.moneyFormat  = root.getAttribute('data-money-format') || '${{amount}}';
    cfg.saleLabel    = root.getAttribute('data-sale-label') || 'Sale';
    cfg.searchesLimit   = parseInt(root.getAttribute('data-searches-limit'), 10) || 4;
    cfg.searchesEnabled = root.getAttribute('data-searches-enabled') !== 'false';
    cfg.currentHandle = document.documentElement.dataset.productHandle || null;
  }

  function isSearchInput(target) {
    return target && target.classList && target.classList.contains('site-header__search-input');
  }
  function inDrawerSearch(target) {
    return target && target.closest && target.closest('#NavDrawer') && isSearchInput(target);
  }

  /* ---------- Event-Handler (Capture-Phase) ---------- */
  function onFocusIn(e) {
    if (!MOBILE_MQ.matches) return;
    if (inDrawerSearch(e.target)) enterSearchMode();
  }
  function onInput(e) {
    if (!MOBILE_MQ.matches) return;
    if (!inDrawerSearch(e.target)) return;
    if (drawer && !drawer.classList.contains('snzm-active')) drawer.classList.add('snzm-active');
    refreshContent(e.target.value);
  }
  function onKeyup(e) {
    if (e.keyCode === 27) { exitSearchMode(true); return; }
    if (!MOBILE_MQ.matches) return;
    if (!inDrawerSearch(e.target)) return;
    if (drawer && !drawer.classList.contains('snzm-active')) drawer.classList.add('snzm-active');
    refreshContent(e.target.value);
  }
  function onSubmit(e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (!f.matches('#DrawerSearchForm, form[action*="/search"]')) return;
    var inp = f.querySelector('input[name="q"]');
    if (inp && inp.value.trim()) rsSave(inp.value.trim());
  }
  function onClick(e) {
    /* Chip-X: einzelne letzte Suche loeschen */
    var x = e.target.closest && e.target.closest('.snzm-chip__x');
    if (x && root && root.contains(x)) {
      e.preventDefault();
      e.stopPropagation();
      var q = x.getAttribute('data-q');
      rsPersist(rsLoad().filter(function (item) { return item !== q; }));
      rsRender();
      return;
    }

    /* Quick Shop (ATC) im Panel */
    var atc = e.target.closest && e.target.closest('[data-mobile-add-to-cart]');
    if (atc && root && root.contains(atc)) {
      e.preventDefault();
      e.stopPropagation();
      var handle = atc.getAttribute('data-handle');
      if (handle) {
        qsSnapshot();
        qsWatchModal(0);
        qsHoldStart();
        triggerQuickShop(handle);
      }
      return;
    }

    /* "Alle Ergebnisse"-Klick: Suche in letzte Suchen aufnehmen */
    var va = e.target.closest && e.target.closest('[data-snzm-viewall]');
    if (va) {
      try {
        var url = new URL(va.href, window.location.origin);
        var vq = url.searchParams.get('q');
        if (vq) rsSave(vq);
      } catch (err) {}
      /* kein return – Navigation laeuft normal weiter */
    }

    if (e.target.closest('.js-snzm-cancel')) {
      e.preventDefault();
      exitSearchMode(true);
      if (input) input.blur();
      return;
    }
    if (e.target.closest('.js-drawer-close')) { exitSearchMode(true); return; }
    if (e.target.closest('.js-search-header-close')) {
      if (e.target.closest('#NavDrawer') && MOBILE_MQ.matches && drawer && drawer.classList.contains('snzm-active')) {
        if (input) input.value = '';
        setState('idle');
        if (input) input.focus();
      }
    }
  }

  function bindDocumentOnce() {
    if (docBound) return;
    docBound = true;
    document.addEventListener('focusin', onFocusIn, true);
    document.addEventListener('input', onInput, true);
    document.addEventListener('keyup', onKeyup, true);
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('shopify:section:load', function () { init(); });
  }

  function init() {
    root = document.querySelector('[data-snzm-search]');
    if (!root) return;
    drawer = document.getElementById('NavDrawer');
    if (!drawer) return;

    cacheEls();
    readCfg();
    input = drawer.querySelector('#DrawerSearchForm .site-header__search-input')
         || drawer.querySelector('.site-header__search-input');

    bindDocumentOnce();
  }

  window.SnzmSearchMobile = { reinit: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();